// oxlint-disable no-explicit-any

/**
 * jQueryのようなライブラリー全般を表すインターフェイス。
 */
interface IJQueryLike {
    length: number;
    eq: (index: number) => this;
    val: () => any;
    prop: (propName: string) => any;
}

/**
 * 指定された要素から文字列を取り出す。
 *
 * @param elem 要素
 * @returns 文字列
 */
export const getStringValFromElem = <T extends IJQueryLike>(elem: T | Element) => {
    if (elem instanceof Element) {
        if (elem instanceof HTMLInputElement || elem instanceof HTMLSelectElement) {
            return elem.value;
        }

        return "";
    } else {
        return "" + elem.val();
    }
};

/**
 * 指定された要素から数値を取り出す。
 *
 * @param elem 要素
 * @returns 数値
 */
export const getNumberValFromElem = <T extends IJQueryLike>(elem: T | Element) => {
    const val = getStringValFromElem(elem);
    const parsed = Number.parseFloat(val);
    if (Number.isFinite(parsed)) {
        return parsed;
    } else {
        throw new TypeError(`${val} cannot be parsed as number.`);
    }
};

/**
 * 指定された要素にチェックが入っているかどうかを返す。
 *
 * @param elem 要素
 * @returns チェックされているかどうか
 */
export const isCheckedElem = <T extends IJQueryLike>(elem: T | Element) => {
    if (elem instanceof Element) {
        return (elem instanceof HTMLInputElement) ? elem.checked : false;
    } else {
        return !!elem.prop("checked");
    }
};

/**
 * 指定された要素から日付を取り出す。
 *
 * @param elem 要素
 * @returns 日付
 */
export const getDateValFromElem = <T extends IJQueryLike>(elem: T | Element) => {
    const str = getStringValFromElem(elem);
    const date = new Date(str.replaceAll("/", "-").trim());
    if (Number.isNaN(date.getTime())) {
        throw new TypeError(`${str} cannot be parsed as date.`);
    } else {
        return date;
    }
};
